import angular from 'angular';
import blogDetailComponent from './blog-detail.component';
import BlogDetailService from './blog-detail.service';
import blogDetailConfig from './blog-detail.config';

let blogDetailModule = angular.module('app.blogDetail',[])
  .component('blogDetail', blogDetailComponent)
  .service('BlogDetailService', BlogDetailService)
  .config(blogDetailConfig);

export default blogDetailModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/blog/blog-detail/blog-detail.js
 **/